import _ from 'lodash';
import Validator from 'validatorjs';
import React, { Component } from 'react';
import { Guardian } from '@xaamin/guardian';
import { Button, Col, Row } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { FormControl } from '../../../../../facturotopia';
import CartaPorteDomicilioForm from './CartaPorteDomicilioForm';
import CartaPorteNumEstacionSuggestions from './suggestions/CartaPorteNumEstacionSuggestions';
import CartaPorteUbicacionesUploadFile from './CartaPorteUbicacionesUploadFile';
import CartaPorteClienteManager from '../../../../catalogs/managers/CartaPorteClienteManager';
import CartaPorteCatalogoManager from '../../../../catalogs/managers/CartaPorteCatalogoManager';

class CartaPorteUbicacionForm extends Component {
  state = {}

  constructor(props) {
    super(props);

    this.state = {
      data: {},
      show: false,
      isValid: false,
      isValidAddress: false,
      isTouchedDomicilio: false,
      validator: new Validator({}, this.rules({})),
    };
  }

  componentDidMount() {
    const NumEstacion = CartaPorteCatalogoManager.get('c_cp_estaciones');
    const TipoEstacion = CartaPorteCatalogoManager.get('c_cp_tipo_estacion');

    //Catalogo de ubicaciones cliente dish
    const { ubicaciones } = CartaPorteClienteManager.get('carta-porte');
    let catalogos = {}

    catalogos.ClienteUbicaciones = this.getSortedCatalogoCliente(ubicaciones);
    catalogos.NumEstacion = this.getSortedCatalogo(NumEstacion);
    catalogos.TipoEstacion = this.getCatalogo(TipoEstacion);

    this.setState({
      catalogos
    });
  }

  componentDidUpdate() {
    const { data } = this.props;

    if (!!data) {
      this.setState({
        data: {
          ...data,
        },
        ubicacionDomicilioChecked: !!data.Domicilio,
        isValid: true
      });
    }
  }

  rules(data) {
    const { data: internal = {} } = this.state;

    let isTipoUbicacionDestino = internal.TipoUbicacion === 'Destino' ? true : false;

    return {
      'TipoUbicacion': ['required', 'in:Origen,Destino'],
      'IDUbicacion': ['required', 'string', 'regex:/^([OR|DE]{2}[0-9]{6})$/'],
      'RFCRemitenteDestinatario': ['required', 'string', 'min:12', 'max:13', 'regex:/^[A-Z&Ñ]{3,4}[0-9]{2}(0[1-9]|1[012])(0[1-9]|[12][0-9]|3[01])[A-Z0-9]{2}[0-9A]$/'],
      'NombreRemitenteDestinatario': ['string', 'min:1', 'max:254'],
      'NumRegIdTrib': ['min:6'],
      'ResidenciaFiscal': ['string'],
      'NumEstacion': ['string'],
      'NombreEstacion': ['string', 'min:1', 'max:50'],
      'NavegacionTrafico': ['string', 'in:Altura,Cabotaje'],
      'FechaHoraSalidaLlegada': ['required'],
      'TipoEstacion': ['string'],
      'DistanciaRecorrida': isTipoUbicacionDestino ? ['numeric', 'min:0.01', 'max:99999'].concat(['required']) : ['numeric', 'min:0.01', 'max:99999']
    }
  }

  getCatalogo = (values) => {
    if (!!values) {
      return [
        {
          label: 'Selecciona',
          value: ''
        }
      ].concat(this.getSortedCatalogo(values));
    }
  }

  getSortedCatalogo = (values) => {
    if (!values) {
      return [];
    }

    return _.sortBy(values.map((item) => {
      return {
        label: item.descripcion,
        value: item.clave
      }
    }), 'label');
  }

  getSortedCatalogoCliente = (values, label, id) => {
    if (!values) {
      return [];
    }

    return _.sortBy(values.map((item) => {
      return {
        label: `${item.id} - ${item.nombre}`,
        value: item[id],
        id: item.id,
        tipo: item.tipo,
        rfc: item.rfc,
        nombre: item.nombre,
        numero_registro_fiscal: item.numero_registro_fiscal,
        residencia_fiscal: item.residencia_fiscal,
        numero_estacion: item.numero_estacion,
        nombre_estacion: item.nombre_estacion,
        navegacion_trafico: item.navegacion_trafico,
        tipo_estacion: item.tipo_estacion,
        calle: item.calle,
        numero_exterior: item.numero_exterior,
        numero_interior: item.numero_interior,
        colonia: item.colonia,
        localidad: item.localidad,
        referencia: item.referencia,
        municipio: item.municipio,
        c_estado: item.c_estado,
        estado: item.estado,
        pais: item.pais,
        codigo_postal: item.codigo_postal,
      }
    }), 'label');
  }

  handleOnUbicacionesChange = (value) => {
    let data = {
      ...this.state.data,
      ...value,
    }

    if (!_.isEmpty(value)) {
      data = {
        ...this.state.data,
        ClienteUbicaciones: value.id.toString(),
        TipoUbicacion: value.tipo.toString(),
        IDUbicacion: value.id.toString(),
        RFCRemitenteDestinatario: value.rfc.toString(),
        NombreRemitenteDestinatario: value.nombre.toString(),
        NumRegIdTrib: value.numero_registro_fiscal.toString(),
        ResidenciaFiscal: value.residencia_fiscal.toString(),
        NumEstacion: value.numero_estacion.toString(),
        NombreEstacion: value.nombre_estacion.toString(),
        NavegacionTrafico: value.navegacion_trafico.toString(),
        TipoEstacion: value.tipo_estacion.toString(),
        Domicilio: {
          CodigoPostal: value.codigo_postal.toString(),
          Calle: value.calle.toString(),
          NumeroExterior: value.numero_exterior.toString(),
          NumeroInterior: value.numero_interior.toString(),
          Colonia: value.colonia.toString(),
          Localidad: value.localidad.toString(),
          Referencia: value.referencia.toString(),
          Municipio: value.municipio.toString(),
          Estado: value.c_estado.toString(),
          Pais: value.pais.toString(),
        }
      };
    }

    this.handleOnChange(data);
  }

  handleOnChange = (value) => {
    const data = {
      ...this.state.data,
      ...value
    }

    const validator = this.validate(data);

    this.setState({
      data,
      isValid: validator.passes(),
    });
  }

  validate(data) {
    const validator = new Validator(data, this.rules(data));

    validator.check();

    this.setState({
      validator
    });

    return validator;
  }

  handleOnDomicilioDataChange = (event) => {
    const data = {
      ...this.state.data.Domicilio,
      ...event.data,
    }

    this.setState({
      data: {
        ...this.state.data,
        Domicilio: data,
      },
      isValidAddress: event.isValid,
      isTouchedDomicilio: event.isTouched
    });
  }

  handleOnAdd = () => {
    const data = this.state.data;

    const newData = {
      ...data,
    }

    this.props.onAdd(newData);

    this.setState({
      isValid: false,
      ubicacionDomicilioChecked: false,
      data: {}
    })
  }

  handleOnRef = (ref) => {
    this._refNumEstacion = ref.ref;
  }

  handleOnRefreshData = () => {
    this.setState({
      isValid: false,
      ubicacionDomicilioChecked: false,
      data: {}
    })
  }

  handleOnShow = () => {
    this.setState({
      show: true
    });
  }

  handleOnClose = (values) => {
    this.setState({
      ...this.state.data,
      ...values
    });
  }

  handleOnAddFile = (values) => {
    this.props.onAddFile(values);
  }

  render() {
    const rules = this.rules();
    const { isValid, isValidAddress, isTouchedDomicilio, data = {}, catalogos = {}, show } = this.state;

    return (
      <>
        <Row className="pb-2">
          <Col sm md={ 11 }>
            <FormControl type="ahead"
              label="Catálogo Ubicaciones"
              id="ClienteUbicaciones"
              name="ClienteUbicaciones"
              help=""
              value={ data.ClienteUbicaciones }
              placeholder={ data.ClienteUbicaciones }
              options={ catalogos.ClienteUbicaciones }
              onSelect={ this.handleOnUbicacionesChange }
            />
          </Col>

          <Col sm md={ 1 } className="text-right" style={ { marginTop: "28px" } }>
            <Button
              size="lg"
              variant="secondary"
              onClick={ this.handleOnRefreshData }
            >
              <FontAwesomeIcon icon={ ['fas', 'trash'] } />
            </Button>
          </Col>
        </Row>

        <Row>
          <Col sm md={ 4 }>
            <FormControl type="select"
              label="Tipo Ubicación"
              name="TipoUbicacion"
              placeholder=""
              help=""
              rules={ rules.TipoUbicacion }
              value={ data.TipoUbicacion }
              options={ ClaveTransporteOptions }
              onChange={ this.handleOnChange }
            />
          </Col>

          <Col sm md={ 4 }>
            <FormControl type="text"
              label="ID Ubicación"
              name="IDUbicacion"
              placeholder=""
              help=""
              casing={ 'upper' }
              minLength="8"
              maxLength="8"
              rules={ rules.IDUbicacion }
              value={ data.IDUbicacion }
              onChange={ this.handleOnChange }
            />
          </Col>

          <Col sm md={ 4 }>
            <FormControl type="text"
              label="RFC Remitente/Destinatario"
              name="RFCRemitenteDestinatario"
              placeholder=""
              casing={ 'upper' }
              help=""
              minLength="12"
              maxLength="13"
              rules={ rules.RFCRemitenteDestinatario }
              value={ data.RFCRemitenteDestinatario }
              onChange={ this.handleOnChange }
            />
          </Col>

          <Col sm md={ 4 }>
            <FormControl type="text"
              label="Nombre Remitente/Destinatario"
              name="NombreRemitenteDestinatario"
              placeholder=""
              help=""
              minLength="1"
              maxLength="254"
              rules={ rules.NombreRemitenteDestinatario }
              value={ data.NombreRemitenteDestinatario }
              onChange={ this.handleOnChange }
            />
          </Col>

          <Col sm md={ 4 }>
            <FormControl type="number"
              label="Número de Registro ID Tributario"
              name="NumRegIdTrib"
              placeholder=""
              help=""
              minLength="6"
              maxLength="40"
              rules={ rules.NumRegIdTrib }
              value={ data.NumRegIdTrib }
              onChange={ this.handleOnChange }
            />
          </Col>

          <Col sm md={ 4 }>
            <FormControl type="text"
              label="Residencia Fiscal"
              name="ResidenciaFiscal"
              placeholder=""
              help=""
              minLength="3"
              maxLength="3"
              rules={ rules.ResidenciaFiscal }
              value={ data.ResidenciaFiscal }
              // opntions={ }
              onChange={ this.handleOnChange }
            />
          </Col>

          <Col sm md={ 4 }>
            <CartaPorteNumEstacionSuggestions
              label="Número de Estación"
              id="NumEstacion"
              name="NumEstacion"
              help=""
              selected={ data.NumEstacion }
              placeholder={ data.NumEstacion }
              options={ catalogos.NumEstacion }
              rules={ rules.NumEstacion }
              value={ data.NumEstacion }
              onRef={ this.handleOnRef }
              onChange={ this.handleOnChange }
            />
          </Col>

          <Col sm md={ 4 }>
            <FormControl type="text"
              label="Nombre Estación"
              name="NombreEstacion"
              placeholder=""
              help=""
              minLength="1"
              maxLength="50"
              rules={ rules.NombreEstacion }
              value={ data.NombreEstacion }
              onChange={ this.handleOnChange }
            />
          </Col>

          <Col sm md={ 4 }>
            <FormControl type="select"
              label="Navegación Tráfico"
              name="NavegacionTrafico"
              placeholder=""
              help=""
              rules={ rules.NavegacionTrafico }
              value={ data.NavegacionTrafico }
              options={ NavegacionTraficoOptions }
              onChange={ this.handleOnChange }
            />
          </Col>

          <Col sm md={ 4 }>
            <FormControl type="datetime-picker"
              id="FechaHoraSalidaLlegada"
              label="Fecha Hora Salida/Llegada"
              name="FechaHoraSalidaLlegada"
              rules={ rules.FechaHoraSalidaLlegada }
              value={ data.FechaHoraSalidaLlegada }
              onChange={ this.handleOnChange }
            />
          </Col>

          <Col sm md={ 4 }>
            <FormControl type="select"
              label="Tipo Estación"
              name="TipoEstacion"
              placeholder=""
              help=""
              minLength="16"
              maxLength="36"
              rules={ rules.TipoEstacion }
              value={ data.TipoEstacion }
              options={ catalogos.TipoEstacion }
              onChange={ this.handleOnChange }
            />
          </Col>

          <Col sm md={ 4 }>
            <FormControl type="number"
              label="Distancia Recorrida"
              name="DistanciaRecorrida"
              placeholder=""
              help=""
              rules={ rules.DistanciaRecorrida }
              value={ data.DistanciaRecorrida }
              onChange={ this.handleOnChange }
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <strong>Domicilio Ubicación</strong>
          </Col>
        </Row>

        <CartaPorteDomicilioForm
          data={ data.Domicilio || {} }
          onFormDataChange={ this.handleOnDomicilioDataChange }
        />

        <Row>
          <Col>
            <p className="text-muted">
              Puedes agregar varias Ubicaciones usando el botón "Agregar ubicación", la lista se mostrarán en la tabla de ubicaciones.
            </p>
          </Col>
        </Row>

        <Row className="pt-3">
          { Guardian.allows('excel_cartaporte.access') && (
            <Col>
              <Button variant="secondary"
                onClick={ this.handleOnShow }
              >
                <FontAwesomeIcon icon={ ['fas', 'upload'] } /> Usar excel
              </Button>
            </Col>
          )}

          <Col className="text-right">
            <Button variant="secondary"
              disabled={ !isValid || (!isValidAddress && isTouchedDomicilio) }
              onClick={ this.handleOnAdd }
            >
              Agregar ubicación
            </Button>
          </Col>
        </Row>

        { !!show && (
          <CartaPorteUbicacionesUploadFile
            data={ data }
            show={ show }
            onAdd={ this.handleOnAddFile }
            onClose={ this.handleOnClose }
          />
        )}
      </>
    )
  }
}

const ClaveTransporteOptions = [
  {
    label: "Selecciona",
    value: '',
  },
  {
    "value": "Origen",
    "label": "Origen",
  },
  {
    "value": "Destino",
    "label": "Destino",
  },
];

const NavegacionTraficoOptions = [
  {
    label: "Selecciona",
    value: '',
  },
  {
    "value": "Altura",
    "label": "Altura",
  },
  {
    "value": "Cabotaje",
    "label": "Cabotaje",
  },
];

export default CartaPorteUbicacionForm;
